import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['text', 'output']

  connect(){
    this.previewText();
  }

  previewText() {
    for (let el of this.outputTargets) {
      el.textContent =
        `${this.textTarget.value}`
    }
  }
}